import { ReactQueryStaleTime } from '@openx/constants/react-query';
import type { UsePackageUsedBy } from '@openx/types/package/PackageHookTypes';
import { QueryKeys } from '@openx/utils/api/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { GetPackageUsedByDocument } from '../../../graphql/query/packages/GetPackageUsedBy.generated';
import { getGraphQLRequestFromClient } from '../../../modules/graphql/types';

export const usePackageUsedBy: UsePackageUsedBy = ({ filters, networkOnly = false, enabled = true }) => {
  const { data, isLoading } = useQuery({
    enabled: enabled && filters.package_uid.length > 0,
    queryFn: ({ client }) => getGraphQLRequestFromClient(client)(GetPackageUsedByDocument, filters),
    queryKey: [QueryKeys.PACKAGE_USED_BY, filters],
    staleTime: networkOnly ? 0 : ReactQueryStaleTime.MINUTES_15,
  });

  const parsedData = data?.packageUsedBy?.map(data => {
    return {
      deals_referenced: data?.deals_referenced ?? 0,
      deals_with_rbo: data?.deals_with_rbo ?? 0,
      deals_with_rbo_dynamic: data?.deals_with_rbo_dynamic ?? 0,
      floorrules_referenced: data?.floorrules_referenced ?? 0,
      uid: data?.uid ?? '',
    };
  });

  return { data: parsedData ?? [], isLoading };
};
